/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { combineReducers } from 'redux';
import { albumListReducer } from './AlbumList/reducer';
import { songListReducer } from './SongList/reducer';
import { playlistSearchReducer } from './PlaylistSearch/reducer';
import { playlistStatisticReducer } from './PlaylistStatistics/reducer';
import { songEditReducer } from './SongEdit/reducer';
import { albumEditReducer } from './AlbumEdit/reducer';

export const playlistAdminReducer = combineReducers({
    albumList: albumListReducer,
    albumEdit: albumEditReducer,
    songList: songListReducer,
    playlistSearch: playlistSearchReducer,
    statistics: playlistStatisticReducer,
    songEdit: songEditReducer
});
